import React from 'react';
import Card from 'react-bootstrap/Card';
import { ImLocation2 } from "react-icons/im";
import { IoCallOutline } from "react-icons/io5";
import { GoClockFill } from "react-icons/go";
import { CiTwitter, CiFacebook, CiInstagram, CiLinkedin } from "react-icons/ci";

function Footer() {
  return (
    <div>
      <Card
        className="bg-dark text-white"
        style={{
          width: '100%',
          height: '380px',
          margin: '20px auto',
          padding: '20px',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
          borderRadius: '0px',
        }}
      >
        <div style={{
          textAlign: 'left',
          padding: '20px',
          display: 'flex',
          justifyContent: 'space-around',
          flexWrap: 'wrap'
        }}>
          {/* Address */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ImLocation2 style={{ fontSize: '32px', color: '#fff' }} />
            <h3 style={{ fontSize: '20px', color: '#fff', marginTop: '10px' }}>Address</h3>
            <p style={{ fontSize: '16px', color: '#fff', marginTop: '10px', textAlign: 'center' }}>
              Head Office: King Road Tower, 2nd Floor, Office 1207<br />
              Malik Road, Jeddah, Kingdom of Saudi Arabia
            </p>
          </div>

          {/* Contact */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <IoCallOutline style={{ fontSize: '32px', color: '#fff' }} />
            <h3 style={{ fontSize: '20px', color: '#fff', marginTop: '10px' }}>Contact</h3>
            <p style={{ fontSize: '16px', marginTop: '10px' }}>
              <a href="tel:0546040748" style={{ color: '#fff', textDecoration: 'none' }}>
                Phone: 054 604 0748
              </a>
            </p>
            <p style={{ fontSize: '16px', marginTop: '5px' }}>
             <a href="mailto:almaccompany@gmail.com">almaccompany@gmail.com</a> 
              
            </p>
          </div>

          {/* Working Hours */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <GoClockFill style={{ fontSize: '32px', color: '#fff' }} />
            <h3 style={{ fontSize: '20px', color: '#fff', marginTop: '10px' }}>Opening Hours</h3>
            <p style={{ fontSize: '16px', color: '#fff', marginTop: '10px' }}>Mon–Sun: 9AM – 5PM</p>
            <p style={{ fontSize: '16px', color: '#fff', marginTop: '5px' }}>Friday: Closed</p>
          </div>

          {/* Social Media */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h3 style={{ fontSize: '20px', color: '#fff', marginTop: '10px' }}>Follow Us</h3>
            <div style={{ display: 'flex', justifyContent: 'space-around', width: '180px', marginTop: '10px' }}>
              <CiTwitter style={{ fontSize: '40px', color: '#fff', cursor: 'pointer' }} />
              <CiFacebook style={{ fontSize: '40px', color: '#fff', cursor: 'pointer' }} />
              <a
                href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <CiInstagram style={{ fontSize: '40px', color: '#fff', cursor: 'pointer' }} />
              </a>
              <CiLinkedin style={{ fontSize: '40px', color: '#fff', cursor: 'pointer' }} />
            </div>
          </div>
        </div>
        <p style={{
            textAlign: 'center',
            color: '#fff',
            marginTop: '20px',
            fontSize: '16px', // Increased font size
            fontWeight: '500'
          }}>
            © Copyright <strong>Almac</strong>. All Rights Reserved<br />
            Designed by <a href="#" style={{ color: '#00e0ff', textDecoration: 'none' }}>Wizzo Software</a>
          </p>
          </Card>
          </div>
           );
           }

export default Footer;
